import * as React from "react";

const SVGPayIn = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.9">
        <circle cx="20" cy="20" r="20" fill="url(#paint0_linear_14_73)" />
        <circle
          cx="20"
          cy="20"
          r="19.5"
          stroke="url(#paint1_linear_14_73)"
          stroke-opacity="0.22"
        />
      </g>
      <path
        opacity="0.2"
        d="M22.8872 11.8411C23.3871 12.0214 23.8704 12.2448 24.3317 12.5087C25.8804 13.4016 27.1138 14.7531 27.8617 16.3767C28.6097 18.0004 28.8352 19.8162 28.5073 21.5735L22.893 18.3321L22.8872 11.8411Z"
        fill="var(--primary-theme-color)"
      />
      <path
        d="M22.1667 18.3291C22.1676 18.4565 22.2018 18.5814 22.266 18.6914C22.3302 18.8014 22.422 18.8927 22.5324 18.9562L28.1467 22.1976C28.2467 22.2565 28.3595 22.2904 28.4753 22.2963C28.5912 22.3023 28.7068 22.2801 28.8123 22.2318C28.9178 22.1835 29.0101 22.1104 29.0812 22.0187C29.1524 21.9271 29.2004 21.8196 29.2211 21.7054C29.5703 19.8013 29.3225 17.8357 28.5117 16.0778C27.7009 14.3199 26.3666 12.8556 24.6914 11.8852C24.1942 11.5992 23.6728 11.3573 23.1333 11.1623C23.0237 11.1243 22.9065 11.1133 22.7917 11.1303C22.6769 11.1473 22.5679 11.1917 22.474 11.2599C22.3879 11.3168 22.3158 11.3925 22.263 11.4812C22.2004 11.5913 22.1678 11.716 22.1687 11.8427L22.1667 18.3291ZM27.9235 20.4052L23.6114 17.9156L23.6079 12.9335C23.7372 12.9977 23.8542 13.0653 23.9711 13.1328C25.2342 13.8652 26.2711 14.9313 26.9683 16.2141C27.6655 17.4969 27.996 18.947 27.9235 20.4052Z"
        fill="var(--primary-theme-color)"
      />
      <path
        d="M19.968 29.359C19.9813 29.356 19.9953 29.3568 20.0082 29.3614L20.0652 29.3527C21.6991 29.3445 23.3024 28.9086 24.7154 28.0882C26.1285 27.2678 27.302 26.0916 28.1193 24.6767C28.2148 24.5113 28.2407 24.3147 28.1912 24.1301C28.1418 23.9456 28.021 23.7883 27.8556 23.6928L20.7285 19.5779L20.7261 11.3526C20.7278 11.2578 20.7106 11.1635 20.6755 11.0754C20.6403 10.9874 20.5879 10.9072 20.5212 10.8397C20.4546 10.7722 20.3752 10.7186 20.2876 10.6823C20.2 10.6459 20.106 10.6274 20.0112 10.6279L19.9956 10.6189L19.9431 10.6198C17.884 10.6303 15.8857 11.3192 14.2577 12.5799C12.6296 13.8406 11.4624 15.6028 10.9369 17.5938C10.4113 19.5847 10.5566 21.6934 11.3504 23.5934C12.1441 25.4934 13.542 27.0788 15.3276 28.1042C16.7381 28.9211 18.3381 29.3537 19.968 29.359ZM26.4803 24.5622C25.8179 25.4985 24.9606 26.2802 23.9673 26.8536C22.974 27.427 21.8682 27.7784 20.7262 27.8837L20.7334 21.2443L26.4803 24.5622ZM13.1477 16.0329C13.7844 14.9354 14.6745 14.0063 15.7436 13.323C16.8127 12.6398 18.0298 12.2224 19.2932 12.1056L19.2899 27.8862C17.9655 27.7655 16.6928 27.3134 15.589 26.5714C14.4853 25.8295 13.586 24.8217 12.9741 23.6409C12.3623 22.4601 12.0574 21.1443 12.0878 19.8147C12.1181 18.4851 12.4826 17.1846 13.1477 16.0329Z"
        fill="var(--primary-theme-color)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_14_73"
          x1="0.885609"
          y1="20"
          x2="39.5572"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F4FFF7" />
          <stop offset="1" stop-color="#F4FFF7" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_14_73"
          x1="0.442805"
          y1="26.9231"
          x2="40.0012"
          y2="26.8806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--primary-theme-color)" />
          <stop offset="1" stop-color="var(--primary-theme-color)" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default SVGPayIn;
